import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";

const LandingPage = () => {
  const [selectedVersions, setSelectedVersions] = useState([]);

  const data = [
    { version: "3.2.33", suite: "Smoke", passRate: "55%" },
    { version: "3.1.0", suite: "Smoke", passRate: "66%" },
  ];

  const onRowSelect = (event) => {
    setSelectedVersions(event.value);
  };

  const onCompareSelected = () => {
    alert(`Comparing versions: ${selectedVersions.map((v) => v.version).join(", ")}`);
  };

  const editButtonTemplate = (rowData) => {
    return (
      <Button
        icon="pi pi-pencil"
        className="p-button-text"
        onClick={() => alert(`Navigating to edit page for ${rowData.version}`)}
      />
    );
  };

  return (
    <div className="p-p-4" style={{ fontFamily: "Arial, sans-serif" }}>
      <h1>Landing Page</h1>
      <p>Filters here as usual for GameTeam/Version/etc :</p>
      <p>Table from where we can select the versions to compare or have a chronological view or edit single page reports</p>

      <DataTable
        value={data}
        selectionMode="checkbox"
        selection={selectedVersions}
        onSelectionChange={onRowSelect}
        dataKey="version"
        responsiveLayout="scroll"
        showGridlines="true"
        header="Select versions for comparison"
      >
        <Column selectionMode="multiple" style={{ width: "3em" }} />
        <Column field="version" header="Version" sortable />
        <Column field="suite" header="Suite" sortable />
        <Column field="passRate" header="Pass Rate" sortable />
        <Column body={editButtonTemplate} header="Edit" />
      </DataTable>
    <br/>
      <Button
        label="Compare Selected"
        icon="pi pi-check"
        style={{ width: "200px" }}
        className="p-mt-3"
        onClick={onCompareSelected}
      />
    </div>
  );
};

export default LandingPage;
